import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import {Observable} from 'rxjs';
import {UserService} from "@core/shared/services/user.service";
import {User} from "@core/shared/models/user";
import {filter, map} from "rxjs/operators";
import {Role} from "@core/shared/models/role";

/**
 * Exemple :
 *
 * rolesItems: [
 *      ['ROLE_ADMIN'],
 *      ['ROLE_OFFER_CREATOR', 'ROLE_OFFER_DISTRIBUTOR']
 * ]
 *
 * ==> Le gardien vérifie que l'utilisateur connecté possède le rôle ROLE_ADMIN ou l'ensemble des rôles ROLE_OFFER_CREATOR / ROLE_OFFER_DISTRIBUTOR
 */
@Injectable({
    providedIn: 'root'
})
export class RoleGuard {

    constructor(
        private _userService: UserService
    ) {}

    public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

        return this._userService.currentUser.pipe(filter(user => !!user), map(user => this._canActivate(user, route, state)));
    }

    public _canActivate(user: User, route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {

        if (!user) {

            return false;
        }

        if(!('rolesItems' in route.data)){

            throw new Error('Missing parameters.');
        }

        const rolesItems: Role[][] = route.data.rolesItems;

        return rolesItems.some((rolesItem: Role[]): boolean => {

            return this._userService.hasAllOfThisRoles(user, rolesItem);
        });
    }
}
